'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import JobMonitorDashboard from './components/JobMonitorDashboard';

export default function JobMonitorPage() {
  return (
    <AppLayout>
      <JobMonitorDashboard />
    </AppLayout>
  );
}
